import {
  EHospitalStatus,
  IMutationQuery,
  INetworkHospitalConfig,
  INetworkHospitalResponse,
  IQuery,
} from '@/types';
import { employeeExperienceAxiosInstance } from '@/utils';
import Cookies from 'js-cookie';

// const MOCK_DATA = {
//   total: 10229,
//   next: 10,
//   list: [
//     {
//       name: 'Aster Hospital',
//       address:
//         'plot 2,3&4, sadaramangala industrial area, opp to itpl main gate, whitefield ',
//       city: 'bangalore',
//       state: 'karnataka',
//       pincode: '560066',
//       location: {
//         type: 'Point',
//         coordinates: [77.733676, 12.9895449],
//       },
//       googleMaps: {
//         placeId: 'ChIJKbNMTagRrjsRDX0itEVFtLE',
//         cid: '12804935806198381837',
//         url: 'https://maps.google.com/?cid=12804935806198381837',
//       },
//       id: '5TEDSZABTRDxYqELNgXQ',
//       website: '',
//       email: [
//         'tpbill.whitefield@asterhospital.com',
//         'ipbill.whitefield@asterhospital.com',
//         'raghavendra.gn@icicilombard.com',
//         'raviraj.narayan@icicilombard.com',
//         'mayank.bhargava@icicilombard.com',
//         'amar.varma@icicilombard.com',
//         'chetan.koppar@asterhospital.com',
//       ],
//       phone: ['9986893562'],
//       sort: [0.0864880553819878],
//       distance: 86.48805538198779,
//     },
//     {
//       name: 'Cloudnine Hospital',
//       address:
//         'second floor, nagarjuna sai signet, itpl main road, kiadb export promotion industrial area, white fi ',
//       city: 'bangalore',
//       state: 'karnataka',
//       pincode: '560066',
//       location: {
//         type: 'Point',
//         coordinates: [77.73222059999999, 12.9877767],
//       },
//       googleMaps: {
//         placeId: 'ChIJa0vYVgcOrjsRXKoeg5IpicQ',
//         cid: '14161896212485024348',
//         url: 'https://maps.google.com/?cid=14161896212485024348',
//       },
//       id: 'LbICSZABsE6hygH4xFFx',
//       website: '',
//       email: [
//         'insurancewhfip@cloudninecare.com',
//         'dineshs@cloudninecare.com',
//         'satishhs@cloudninecare.com',
//         'puttaswamy.ap@icicilombard.com',
//         'raviraj.narayan@icicilombard.com',
//         'amar.varma@icicilombard.com',
//         'mayank.bhargava@icicilombard.com',
//       ],
//       phone: [],
//       sort: [0.22208137818307705],
//       distance: 222.08137818307705,
//     },
//     {
//       name: 'Sapthagiri Hospital',
//       address: 'h no: 2-2-2, bridge junction, beside fuse of call, jammikunta ',
//       city: 'karimnagar',
//       state: 'telangana',
//       pincode: '505122',
//       location: {
//         type: 'Point',
//         coordinates: [77.7168157, 13.004705],
//       },
//       googleMaps: {
//         placeId: 'ChIJSdvAIOIRrjsRKguZ6roCfD4',
//         cid: '4502476729286724394',
//         url: 'https://maps.google.com/?cid=4502476729286724394',
//       },
//       id: 'IrICSZABsE6hygH4A0ez',
//       website: '',
//       email: [
//         'insurance.sapthagirihospital@gmail.com',
//         'pottimurthy.praveenkumar@icicilombard.com',
//         'amar.varma@icicilombard.com',
//         'mayank.bhargava@icicilombard.com',
//       ],
//       phone: ['08727253592'],
//       sort: [2.414308074237499],
//       distance: 2414.308074237499,
//     },
//     {
//       name: 'MTB Orthopaedic & Trauma Hospital',
//       address: 'whitefield main road, mahadevapura ',
//       city: 'bangalore',
//       state: 'karnataka',
//       pincode: '560048',
//       location: {
//         type: 'Point',
//         coordinates: [77.7499467, 12.9697999],
//       },
//       googleMaps: {
//         placeId: 'ChIJgZ2FcE0NrjsRTBmZM5YV02s',
//         cid: '7769577516999186764',
//         url: 'https://maps.google.com/?cid=7769577516999186764',
//       },
//       id: 'm7ICSZABsE6hygH44VIi',
//       website: '',
//       email: [
//         'mtborthotraumahospital@gmail.com',
//         'raghavendra.gn@icicilombard.com',
//         'raviraj.narayan@icicilombard.com',
//         'mayank.bhargava@icicilombard.com',
//         'amar.varma@icicilombard.com',
//       ],
//       phone: [],
//       sort: [2.8802994990410467],
//       distance: 2880.2994990410466,
//     },
//     {
//       name: 'Columbia Asia Hospitals Pvt Ltd - White Field',
//       address:
//         'ramagundanahalli village survey no. 10p and 12p varthur kodi, varthur hobli',
//       city: 'bangalore',
//       state: 'karnataka',
//       pincode: '560057',
//       location: {
//         type: 'Point',
//         coordinates: [77.7499721, 12.9698196],
//       },
//       googleMaps: {
//         placeId: 'ChIJg3t8GYQNrjsRSKSWpsrBLV0',
//         cid: '6714235695601722440',
//         url: 'https://maps.google.com/?cid=6714235695601722440',
//       },
//       id: 'KrICSZABsE6hygH4X0zI',
//       website: '',
//       email: [
//         'puttaswamy.ap@icicilombard.com',
//         'insurancemhvr@manipalhospitals.com',
//         'manipalhospitalsvarthur@gmail.com',
//         'raviraj.narayan@icicilombard.com',
//         'amar.varma@icicilombard.com',
//         'mayank.bhargava@icicilombard.com',
//       ],
//       phone: [],
//       sort: [2.8803878978347166],
//       distance: 2880.3878978347166,
//     },
//     {
//       name: 'Kinder Womens Hospital And Fertility Centre',
//       address:
//         'no: 40f doddanekundi industrial area, graphite india main road hoodi, village kr puram, hoodi ',
//       city: 'bangalore',
//       state: 'karnataka',
//       pincode: '560048',
//       location: {
//         type: 'Point',
//         coordinates: [77.7063902, 12.9919711],
//       },
//       googleMaps: {
//         placeId: 'ChIJRXFOqQ4RrjsRgaBUgLZ3KHc',
//         cid: '8586244315302633601',
//         url: 'https://maps.google.com/?cid=8586244315302633601',
//       },
//       id: 'mTEDSZABTRDxYqELtQgu',
//       website: '',
//       email: [
//         'insurance.blr@kinderhospitals.com',
//         'puttaswamy.ap@icicilombard.com',
//         'raviraj.narayan@icicilombard.com',
//         'mayank.bhargava@icicilombard.com',
//         'amar.varma@icicilombard.com',
//       ],
//       phone: [],
//       sort: [2.8823716015700254],
//       distance: 2882.371601570025,
//     },
//     {
//       name: 'Dr. Agarwals Eye Hospital Ltd',
//       address:
//         'plot no. 1792, adichunchanagari mutt road,( intersect with sooksagar road), mysore ',
//       city: 'mysore',
//       state: 'karnataka',
//       pincode: '570014',
//       location: {
//         type: 'Point',
//         coordinates: [77.7492692, 12.9660443],
//       },
//       googleMaps: {
//         placeId: 'ChIJSw5zofkNrjsRst9Hq_EpG0Y',
//         cid: '5051677524963614642',
//         url: 'https://maps.google.com/?cid=5051677524963614642',
//       },
//       id: 'YDECSZABTRDxYqEL-gSV',
//       website: '',
//       email: [
//         'mayank.bhargava@icicilombard.com',
//         'mysore@dragarwal.com',
//         'abhishek.m.b@icicilombard.com',
//         'raviraj.narayan@icicilombard.com',
//         'amar.varma@icicilombard.com',
//         'receivables@dragarwal.com',
//         'devraj@dragarwal.com',
//       ],
//       phone: [],
//       sort: [3.1700951797176184],
//       distance: 3170.0951797176185,
//     },
//     {
//       name: 'Dr. Agarwals Eye Hospital Ltd',
//       address: 'survey no.: 32/4, rgt road ',
//       city: 'south andaman',
//       state: 'andaman & nicobar islands',
//       pincode: '744103',
//       location: {
//         type: 'Point',
//         coordinates: [77.7492692, 12.9660443],
//       },
//       googleMaps: {
//         placeId: 'ChIJSw5zofkNrjsRst9Hq_EpG0Y',
//         cid: '5051677524963614642',
//         url: 'https://maps.google.com/?cid=5051677524963614642',
//       },
//       id: 'ADECSZABTRDxYqEL6ARQ',
//       website: '',
//       email: [
//         'portblair@dragarwal.com',
//         'receivables@dragarwal.com',
//         'sourav.das@icicilombard.com',
//         'jaydeep.bhattacharya@icicilombard.com',
//         'mayank.bhargava@icicilombard.com',
//       ],
//       phone: [],
//       sort: [3.1700951797176184],
//       distance: 3170.0951797176185,
//     },
//     {
//       name: 'Dr. Agarwals Eye Hospital Ltd',
//       address: '381, 1st cross narayanappa, garden main road, whitefield ',
//       city: 'bangalore',
//       state: 'karnataka',
//       pincode: '560066',
//       location: {
//         type: 'Point',
//         coordinates: [77.7492692, 12.9660443],
//       },
//       googleMaps: {
//         placeId: 'ChIJSw5zofkNrjsRst9Hq_EpG0Y',
//         cid: '5051677524963614642',
//         url: 'https://maps.google.com/?cid=5051677524963614642',
//       },
//       id: 'C7ICSZABsE6hygH4wFG-',
//       website: '',
//       email: [
//         'devraj@dragarwal.com',
//         'receivables@dragarwal.com',
//         'whitefield@dragarwal.com',
//         'raghavendra.gn@icicilombard.com',
//         'raviraj.narayan@icicilombard.com',
//         'amar.varma@icicilombard.com',
//         'mayank.bhargava@icicilombard.com',
//         'claims@dragarwal.com',
//       ],
//       phone: ['8884477939'],
//       sort: [3.1700951797176184],
//       distance: 3170.0951797176185,
//     },
//     {
//       name: 'Svastha Emergency & Multispeciality Hosptial',
//       address: 'd.no.31-1-24/2a, alamuru road ',
//       city: 'mandapeta',
//       state: 'andhra pradesh',
//       pincode: '533008',
//       location: {
//         type: 'Point',
//         coordinates: [77.74929329999999, 12.9658595],
//       },
//       googleMaps: {
//         placeId: 'ChIJ9WAztx0RrjsRpQ7CP91EnlU',
//         cid: '6169444256592301733',
//         url: 'https://maps.google.com/?cid=6169444256592301733',
//       },
//       id: 'TbIDSZABsE6hygH4S1cs',
//       website: '',
//       email: [
//         'cashless.svasthahospitals@gmail.com',
//         'venkatesh.kotari@icicilombard.com',
//         'amar.varma@icicilombard.com',
//         'mayank.bhargava@icicilombard.com',
//       ],
//       phone: [],
//       sort: [3.1885973688395444],
//       distance: 3188.5973688395443,
//     },
//   ],
// };

export const networkHospitalQuery = ({
  memberId,
  organisationId,
  insurerName,
  type,
  query,
  latitude,
  longitude,
  from,
  size = 10,
  tpaName,
}: {
  memberId?: string;
  organisationId?: string;
  insurerName: string;
  type: EHospitalStatus;
  query: string;
  latitude?: number;
  longitude?: number;
  from: number;
  size: number;
  tpaName: string;
}): IQuery<INetworkHospitalResponse> => {
  return {
    queryKey: [
      'networkHospitals',
      insurerName,
      tpaName,
      memberId,
      organisationId,
      type,
      query,
      latitude,
      longitude,
    ],
    queryFn: async () => {
      const url = `/network-hospitals/search?insurer=${insurerName}&type=${type}&query=${String(
        query
      )}&lat=${latitude}&long=${longitude}&from=${from}&size=${size}&tpa=${tpaName}`;

      // return sleep(1000, MOCK_DATA as INetworkHospitalResponse);

      return (
        await employeeExperienceAxiosInstance.get<INetworkHospitalResponse>(url)
      ).data;
    },
  };
};

export const getNetworkHospitalConfig = (
  insurerName: string | null,
  tpaName: string | null
): IMutationQuery<INetworkHospitalConfig> => {
  let insurer = insurerName;
  let tpa = tpaName;

  if (tpaName === null && insurerName === null) {
    insurer = Cookies.get('nh-insurer-handle') ?? '';
    tpa = Cookies.get('nh-tpa') ?? '';
  }

  return {
    mutationKey: ['nhInsurerConfig', 'persist'],
    // @ts-ignore
    mutationFn: async (variables: { insurer: string; tpa: string }) => {
      if (variables) {
        insurer = variables?.insurer ?? insurer;
        tpa = variables?.tpa ?? tpa;
      }
      const url = `/network-hospitals/enabled`;

      return (
        await employeeExperienceAxiosInstance.post<INetworkHospitalConfig>(
          url,
          {
            insurerHandle: insurer,
            tpa,
          }
        )
      ).data;
    },
  };
};
